import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    editing: undefined,
    nextFolio: undefined,
    record: {
      id: undefined,
      folio: undefined,
      foto: undefined,
      aggressionDate: undefined,
      state: undefined,
      municipality: undefined,
      legalName: undefined,
      chosenName: undefined,
      whereWasFound: undefined,
      whereWasFoundOther: undefined,
      sexualIdentity: undefined,
      sexualIdentityOther: undefined,
      characteristic: undefined,
      characteristicOther: undefined,
      age: undefined,
      nationality: undefined,
      occupation: undefined,
      occupationOther: undefined,
      details: undefined,
      ageGroup: undefined,
      ethnicGroup: undefined,
      ethnicGroupOther: undefined,
      education: undefined,
      educationOther: undefined,
      bornSex: undefined,
      precedents: undefined,
      precedentsOther: undefined,
      weapon: undefined,
      weaponOther: undefined,
      bodyState: undefined,
      bodyStateOther: undefined,
      investigation: undefined,
      lineOfInvestigation: "Crimen de odio",
      lineOfInvestigationOther: undefined,
      sexualViolence: undefined,
      sexualViolenceDetails: undefined,
      tortureViolence: undefined,
      tortureViolenceDetails: undefined,
      wasOffenderFound: undefined,
      wasOffenderFoundDetails: undefined,
      offenderStatus: undefined,
      offenderStatusOther: undefined,
      offenderName: undefined,
      offenderAge: undefined,
      offenderAgeGroup: undefined,
      offenderRelationship: undefined,
      offenderRelationshipOther: undefined,
      mainMediaName: undefined,
      mainMediaDate: undefined,
      mainMediaTitle: undefined,
      mainMediaHasPicture: undefined,
      mainMediaIsPictureOffensive: undefined,
      mainMediaBlameVictim: undefined,
      mainMediaDetails: undefined,
      mainMediaSources: undefined,
      mainMediaLink: undefined,
      otherMedia: [
        {
          mainLink: undefined,
          followUpLink: undefined,
          selected: undefined
        }
      ],
      place: undefined,
      address: undefined,
      lat: undefined,
      lng: undefined,
      victims: [],
      updates: [],
      reviews: [],
      public: true,
      edit_reason: undefined,
      edit_comments: undefined,
      review_reason: undefined,
      review_comments: undefined,
      aggressionDateVisible: true,
      stateVisible: true,
      municipalityVisible: true,
      legalNameVisible: true,
      chosenNameVisible: true,
      whereWasFoundVisible: true,
      sexualIdentityVisible: true,
      characteristicVisible: true,
      ageVisible: true,
      nationalityVisible: true,
      occupationVisible: true,
      detailsVisible: true,
      bodyStateVisible: true,
      weaponVisible: true,
      sexualViolenceVisible: true,
      tortureViolenceVisible: true,
      wasOffenderFoundVisible: true,
      mainMediaLinkVisible: true
    },
    options: undefined,
    yesNoOptions: [
      {
        label: "Sí",
        slug: "si"
      },
      {
        label: "No",
        slug: "no"
      },
      {
        label: "S/D",
        slug: "sd"
      }
    ],
    host:
      process.env.NODE_ENV === "production"
        ? "https://admin-crimenesdeodio.letraese.org.mx/" //"https://letraese.datacivica.org/"
        : "http://localhost:1337/",
    reports: [],
    filteredReports: [],
    filters: {},
    isLoading: false,
    user: {
      email: "",
      role: "",
      name: "",
      isAuthenticated: false
    },
    userEdit: {
      email: "",
      role: "",
      name: "",
      isAuthenticated: false,
      profileImg: {},
      permission: {}
    },
    userList: [],
    currentToken: "",

    getOptionsAsyncPending: false,
    getOptionsAsyncStatusCode: null,
    getOptionsAsyncData: null,

    getReportsAsyncPending: false,
    getReportsAsyncStatusCode: null,
    getReportsAsyncData: null,

    createReportAsyncPending: false,
    createReportAsyncStatusCode: null,
    createReportAsyncData: null,

    updateReportAsyncPending: false,
    updateReportAsyncStatusCode: null,
    updateReportAsyncData: null,

    deleteReportAsyncPending: false,
    deleteReportAsyncStatusCode: null,
    deleteReportAsyncData: null,

    createUserAsyncPending: false,
    createUserAsyncStatusCode: null,
    createUserAsyncData: null,

    getUsersAsyncPending: false,
    getUsersAsyncStatusCode: null,
    getUsersAsyncData: null,

    updateUsersAsyncPending: false,
    updateUsersAsyncStatusCode: null,
    updateUsersAsyncData: null,

    updateUsersPasswordAsyncPending: false,
    updateUsersPasswordAsyncStatusCode: null,
    updateUsersPasswordAsyncData: null,

    uploadImageAsyncPending: false,
    uploadImageAsyncStatusCode: null,
    uploadImageAsyncData: null,

    updateCsvAsyncPending: false,
    updateCsvAsyncStatusCode: null,
    updateCsvAsyncData: null,

    loginAsyncPending: false,
    loginAsyncStatusCode: null,
    loginAsyncData: null,

    addReviewAsyncPending: false,
    addReviewAsyncStatusCode: null,
    addReviewAsyncData: null
  },
  getters: {
    record: state => state.record,
    reports: state => state.reports,
    filteredReports: state => state.filteredReports,
    filters: state => state.filters,
    userList: state => state.userList,
    userEdit: state => state.userEdit,
    options: state => state.options,
  },
  mutations: {
    setEditionState(state, edit) {
      state.editing = edit;
    },
    setIsLoadingState(state, isLoading) {
      state.isLoading = isLoading;
    },
    setRecord(state, item) {
      state.record = item;
      state.record.id = state.record["_id"];
    },
    resetRecord(state) {
      state.record = {
        //record: {
          id: undefined,
          folio: state.nextFolio,
          foto: {
            url: undefined
          },
          aggressionDate: undefined,
          state: undefined,
          municipality: undefined,
          legalName: undefined,
          chosenName: undefined,
          whereWasFound: undefined,
          sexualIdentity: undefined,
          characteristic: undefined,
          age: undefined,
          nationality: undefined,
          occupation: undefined,
          details: undefined,
          ageGroup: undefined,
          ethnicGroup: undefined,
          education: undefined,
          bornSex: undefined,
          precedents: undefined,
          weapon: undefined,
          bodyState: undefined,
          investigation: undefined,
          lineOfInvestigation: "Crimen de odio",
          sexualViolence: undefined,
          sexualViolenceDetails: undefined,
          tortureViolence: undefined,
          tortureViolenceDetails: undefined,
          wasOffenderFound: undefined,
          wasOffenderFoundDetails: undefined,
          offenderStatus: undefined,
          offenderName: undefined,
          offenderAge: undefined,
          offenderAgeGroup: undefined,
          offenderRelationship: undefined,
          mainMediaName: undefined,
          mainMediaDate: undefined,
          mainMediaTitle: undefined,
          mainMediaHasPicture: undefined,
          mainMediaIsPictureOffensive: undefined,
          mainMediaBlameVictim: undefined,
          mainMediaDetails: undefined,
          mainMediaSources: undefined,
          mainMediaLink: undefined,
          otherMedia: [
            {
              mainLink: undefined,
              followUpLink: undefined,
              selected: undefined
            }
          ],
          place: undefined,
          address: undefined,
          lat: undefined,
          lng: undefined,
          victims: [],
          updates: [],
          reviews: [],
          public: true,
          edit_reason: undefined,
          edit_comments: undefined,
          review_reason: undefined,
          review_comments: undefined,
          aggressionDateVisible: true,
          stateVisible: true,
          municipalityVisible: true,
          legalNameVisible: true,
          chosenNameVisible: true,
          whereWasFoundVisible: true,
          sexualIdentityVisible: true,
          characteristicVisible: true,
          ageVisible: true,
          nationalityVisible: true,
          occupationVisible: true,
          detailsVisible: true,
          bodyStateVisible: true,
          weaponVisible: true,
          sexualViolenceVisible: true,
          tortureViolenceVisible: true,
          wasOffenderFoundVisible: true,
          mainMediaLinkVisible: true
        //}
      };
    },
    resetReview(state) {
      state.record.review_reason = undefined;
      state.record.review_comments = undefined;
    },
    setUser(state, user) {
      state.user = user;
      state.user.isAuthenticated = true;
      localStorage.setItem(
        "rompeelmiedo.org",
        JSON.stringify({ user: state.user })
      );
    },
    resetUser(state) {
      state.user = {
        email: "",
        role: "",
        isAuthenticated: false,
        name: ""
      };
      localStorage.clear();
    },
    setUserEdit(state, userInfo) {
      state.userEdit = userInfo;
      state.userEdit.id = userInfo["_id"];
    },
    setUserList(state, list) {
      state.userList = list;
    },

    SET_GETOPTIONS_PENDING(state, payload) {
      state.getOptionsAsyncPending = payload.pending;
    },
    SET_GETOPTIONS_SUCCESS(state, payload) {
      state.getOptionsAsyncStatusCode = payload.statusCode;
      state.getOptionsAsyncData = payload.data;
      state.getOptionsAsyncPending = payload.pending;
      state.options = payload.data.result;
    },
    SET_GETOPTIONS_FAILURE(state, payload) {
      state.getReportsAsyncStatusCode = payload.statusCode;
    },

    SET_GETREPORTS_PENDING(state, payload) {
      state.getReportsAsyncPending = payload.pending;
    },
    SET_GETREPORTS_SUCCESS(state, payload) {
      state.getReportsAsyncStatusCode = payload.statusCode;
      state.getReportsAsyncData = payload.data;
      state.getReportsAsyncPending = payload.pending;
      // console.log(payload.data.result)
      state.reports = payload.data.result;
      const filters = {};
      state.reports.map(report => (filters[report.type] = false));
      state.filteredReports = state.reports;
      state.filters = filters;
      state.nextFolio = payload.data.folio + 1;
      //console.log(state.reports)
      //console.log(state.filteredReports)
    },
    SET_GETREPORTS_FAILURE(state, payload) {
      state.getReportsAsyncStatusCode = payload.statusCode;
    },

    SET_CREATEREPORT_PENDING(state, payload) {
      state.createReportAsyncPending = payload.pending;
    },
    SET_CREATEREPORT_SUCCESS(state, payload) {
      state.createReportAsyncStatusCode = payload.statusCode;
      state.createReportAsyncData = payload.data;
      state.createReportAsyncPending = payload.pending;
    },
    SET_CREATEREPORT_FAILURE(state, payload) {
      state.createReportAsyncStatusCode = payload.statusCode;
    },
    SET_UPDATEREPORT_PENDING(state, payload) {
      state.updateReportAsyncPending = payload.pending;
    },
    SET_UPDATEREPORT_SUCCESS(state, payload) {
      state.updateReportAsyncStatusCode = payload.statusCode;
      state.updateReportAsyncData = payload.data;
      state.updateReportAsyncPending = payload.pending;
      // console.log(payload.data.result.value)
    },
    SET_UPDATEREPORT_FAILURE(state, payload) {
      state.updateReportAsyncStatusCode = payload.statusCode;
    },

    SET_DELETEREPORT_PENDING(state, payload) {
      state.deleteReportAsyncPending = payload.pending;
    },
    SET_DELETEREPORT_SUCCESS(state, payload) {
      state.deleteReportAsyncStatusCode = payload.statusCode;
      state.deleteReportAsyncData = payload.data;
      state.deleteReportAsyncPending = payload.pending;
    },
    SET_DELETEREPORT_FAILURE(state, payload) {
      state.deleteReportAsyncStatusCode = payload.statusCode;
    },

    SET_CREATEUSER_PENDING(state, payload) {
      state.createUserAsyncPending = payload.pending;
    },
    SET_CREATEUSERS_SUCCESS(state, payload) {
      state.createUsersAsyncStatusCode = payload.statusCode;
      state.createUsersAsyncData = payload.data;
      state.createUsersAsyncPending = payload.pending;
    },
    SET_CREATEUSERS_FAILURE(state, payload) {
      state.createUsersAsyncStatusCode = payload.statusCode;
    },

    SET_GETUSERS_PENDING(state, payload) {
      state.getUsersAsyncPending = payload.pending;
    },
    SET_GETUSERS_SUCCESS(state, payload) {
      state.getUsersAsyncStatusCode = payload.statusCode;
      state.getUsersAsyncData = payload.data;
      state.getUsersAsyncPending = payload.pending;
      state.userList = payload.data.result;
    },
    SET_GETUSERS_FAILURE(state, payload) {
      state.getUsersAsyncStatusCode = payload.statusCode;
    },

    SET_UPDATEUSERS_PENDING(state, payload) {
      state.updateUsersAsyncPending = payload.pending;
    },
    SET_UPDATEUSERS_SUCCESS(state, payload) {
      state.updateUsersAsyncStatusCode = payload.statusCode;
    },
    SET_UPDATEUSERS_FAILURE(state, payload) {
      state.updateUsersAsyncStatusCode = payload.statusCode;
    },

    SET_UPDATEPASSWORD_PENDING(state, payload) {
      state.updateUsersPasswordAsyncPending = payload.pending;
    },
    SET_UPDATEPASSWORD_SUCCESS(state, payload) {
      state.updateUsersPasswordAsyncStatusCode = payload.statusCode;
    },
    SET_UPDATEPASSWORD_FAILURE(state, payload) {
      state.updateUsersPasswordAsyncStatusCode = payload.statusCode;
    },

    SET_DELETEUSERS_PENDING(state, payload) {
      state.deleteUsersAsyncPending = payload.pending;
    },
    SET_DELETEUSERS_SUCCESS(state, payload) {
      state.deleteUsersAsyncStatusCode = payload.statusCode;
    },
    SET_DELETEUSERS_FAILURE(state, payload) {
      state.deleteUsersAsyncStatusCode = payload.statusCode;
    },

    SET_UPLOADIMAGE_PENDING(state, payload) {
      state.uploadImageAsyncPending = payload.pending;
    },
    SET_UPLOADIMAGE_SUCCESS(state, payload) {
      state.uploadImageAsyncStatusCode = payload.statusCode;
      state.uploadImageAsyncData = payload.data;
      state.uploadImageAsyncPending = payload.pending;
    },
    SET_UPLOADIMAGE_FAILURE(state, payload) {
      state.uploadImageAsyncStatusCode = payload.statusCode;
    },
    SET_UPDATECSV_PENDING(state, payload) {
      state.updateCsvAsyncPending = payload.pending;
    },
    SET_UPDATECSV_SUCCESS(state, payload) {
      state.updateCsvAsyncStatusCode = payload.statusCode;
      state.updateCsvAsyncData = payload.data;
      state.updateCsvAsyncPending = payload.pending;
    },
    SET_UPDATECSV_FAILURE(state, payload) {
      state.updateCsvAsyncStatusCode = payload.statusCode;
    },
    SET_LOGIN_PENDING(state, payload) {
      state.loginAsyncPending = payload.pending;
    },
    SET_LOGIN_SUCCESS(state, payload) {
      state.loginAsyncStatusCode = payload.statusCode;
      state.loginAsyncData = payload.data;
      state.loginAsyncPending = payload.pending;
    },
    SET_LOGIN_FAILURE(state, payload) {
      state.loginAsyncStatusCode = payload.statusCode;
    },
    SET_ADDREVIEW_PENDING(state, payload) {
      state.addReviewAsyncPending = payload.pending;
    },
    SET_ADDREVIEW_SUCCESS(state, payload) {
      state.addReviewAsyncStatusCode = payload.statusCode;
      state.addReviewAsyncData = payload.data;
      state.addReviewAsyncPending = payload.pending;
    },
    SET_ADDREVIEW_FAILURE(state, payload) {
      state.addReviewAsyncStatusCode = payload.statusCode;
    },

    updateFoto(state, foto) {
      state.record.foto = foto;
    },
    updateAggressionDate(state, date) {
      state.record.aggressionDate = date;
    },
    updateState(state, _state) {
      state.record.state = _state;
    },
    updateMunicipality(state, mun) {
      state.record.municipality = mun;
    },
    updateLegalName(state, legalName) {
      state.record.legalName = legalName;
    },
    updateChosenName(state, chosenName) {
      state.record.chosenName = chosenName;
    },
    updateWhereWasFound(state, whereWasFound) {
      state.record.whereWasFound = whereWasFound;
    },
    updateWhereWasFoundOther(state, whereWasFoundOther) {
      state.record.whereWasFoundOther = whereWasFoundOther;
    },
    updateSexualIdentity(state, sexualIdentity) {
      state.record.sexualIdentity = sexualIdentity;
    },
    updateSexualIdentityOther(state, sexualIdentityOther) {
      state.record.sexualIdentityOther = sexualIdentityOther;
    },
    updatecharacteristic(state, characteristic) {
      state.record.characteristic = characteristic;
    },
    updatecharacteristicOther(state, characteristicOther) {
      state.record.characteristicOther = characteristicOther;
    },
    updateAge(state, age) {
      state.record.age = age;
    },
    updateNationality(state, Nationality) {
      state.record.nationality = Nationality;
    },
    updateOccupation(state, occupation) {
      state.record.occupation = occupation;
    },
    updateOccupationOther(state, occupationOther) {
      state.record.occupationOther = occupationOther;
    },
    updateDetails(state, details) {
      state.record.details = details;
    },

    updateAgeGroup(state, ageGroup) {
      state.record.ageGroup = ageGroup;
    },
    updateEthnicGroup(state, ethnicGroup) {
      state.record.ethnicGroup = ethnicGroup;
    },
    updateEthnicGroupOther(state, ethnicGroupOther) {
      state.record.ethnicGroupOther = ethnicGroupOther;
    },
    updateEducation(state, education) {
      state.record.education = education;
    },
    updateEducationOther(state, educationOther) {
      state.record.educationOther = educationOther;
    },
    updateBornSex(state, bornSex) {
      state.record.bornSex = bornSex;
    },
    updatePrecedents(state, precedents) {
      state.record.precedents = precedents;
    },
    updatePrecedentsOther(state, precedentsOther) {
      state.record.precedentsOther = precedentsOther;
    },
    updateWeapon(state, weapon) {
      state.record.weapon = weapon;
    },
    updateWeaponOther(state, weaponOther) {
      state.record.weaponOther = weaponOther;
    },
    updateBodyState(state, bodyState) {
      state.record.bodyState = bodyState;
    },
    updateBodyStateOther(state, bodyStateOther) {
      state.record.bodyStateOther = bodyStateOther;
    },
    updateInvestigation(state, investigation) {
      state.record.investigation = investigation;
    },
    updateLineOfInvestigation(state, lineOfInvestigation) {
      state.record.lineOfInvestigation = lineOfInvestigation;
    },
    updateLineOfInvestigationOther(state, lineOfInvestigationOther) {
      state.record.lineOfInvestigationOther = lineOfInvestigationOther;
    },
    updateSexualViolence(state, sexualViolence) {
      state.record.sexualViolence = sexualViolence;
    },
    updateSexualViolenceDetails(state, sexualViolenceDetails) {
      state.record.sexualViolenceDetails = sexualViolenceDetails;
    },
    updateTortureViolence(state, tortureViolence) {
      state.record.tortureViolence = tortureViolence;
    },
    updateTortureViolenceDetails(state, TortureViolenceDetails) {
      state.record.TortureViolenceDetails = TortureViolenceDetails;
    },
    updateWasOffenderFound(state, wasOffenderFound) {
      state.record.wasOffenderFound = wasOffenderFound;
    },
    updateWasOffenderFoundDetails(state, wasOffenderFoundDetails) {
      state.record.wasOffenderFoundDetails = wasOffenderFoundDetails;
    },
    updateOffenderStatus(state, status) {
      state.record.offenderStatus = status;
    },
    updateOffenderStatusOther(state, statusOther) {
      state.record.offenderStatusOther = statusOther;
    },
    updateOffenderName(state, name) {
      state.record.offenderName = name;
    },
    updateOffenderAge(state, age) {
      state.record.offenderAge = age;
    },
    updateOffenderAgeGroup(state, ageGroup) {
      state.record.offenderAgeGroup = ageGroup;
    },
    updateOffenderRelationship(state, relationship) {
      state.record.offenderRelationship = relationship;
    },
    updateOffenderRelationshipOther(state, relationshipOther) {
      state.record.offenderRelationshipOther = relationshipOther;
    },

    updateMainMediaName(state, mainMediaName) {
      state.record.mainMediaName = mainMediaName;
    },
    updateMainMediaDate(state, mainMediaDate) {
      state.record.mainMediaDate = mainMediaDate;
    },
    updateMainMediaTitle(state, mainMediaTitle) {
      state.record.mainMediaTitle = mainMediaTitle;
    },
    updateMainMediaHasPicture(state, mainMediaHasPicture) {
      state.record.mainMediaHasPicture = mainMediaHasPicture;
    },
    updateMainMediaIsPictureOffensive(state, mainMediaIsPictureOffensive) {
      state.record.mainMediaIsPictureOffensive = mainMediaIsPictureOffensive;
    },
    updateMainMediaBlameVictim(state, mainMediaBlameVictim) {
      state.record.mainMediaBlameVictim = mainMediaBlameVictim;
    },
    updateMainMediaDetails(state, mainMediaDetails) {
      state.record.mainMediaDetails = mainMediaDetails;
    },
    updateMainMediaSources(state, mainMediaSources) {
      state.record.mainMediaSources = mainMediaSources;
    },
    updateMainMediaLink(state, mainMediaLink) {
      state.record.mainMediaLink = mainMediaLink;
    },
    updateOtherMedia(state, otherMedia) {
      state.record.otherMedia = otherMedia;
    },

    updatePlace(state, place) {
      state.record.place = place;
    },
    updateAddress(state, address) {
      state.record.address = address;
    },
    updateLat(state, lat) {
      state.record.lat = lat;
    },
    updateLng(state, lng) {
      state.record.lng = lng;
    },
    updateEditReason(state, edit_reason) {
      state.record["edit_reason"] = edit_reason;
    },
    updateEditComments(state, edit_comments) {
      state.record["edit_comments"] = edit_comments;
    },
    updateReviewReason(state, review_reason) {
      state.record["review_reason"] = review_reason;
    },
    updateReviewComments(state, review_comments) {
      state.record["review_comments"] = review_comments;
    },
    updatePublic(state, _public) {
      state.record.public = _public;
    },
    updateUserName(state, _name) {
      state.userEdit.name = _name;
    },
    updateUserEmail(state, _email) {
      state.userEdit.email = _email;
    },
    updateUserRole(state, _role) {
      state.userEdit.role = _role;
    },
    updateUserPassword(state, _password) {
      state.userEdit.password = _password;
    },
    updateUserProfileImg(state, _profileImg) {
      state.userEdit.profileImg = _profileImg;
    },

    updateAggressionDateVisible(state, value) {
      state.record.aggressionDateVisible = value;
    },
    updateStateVisible(state, value) {
      state.record.stateVisible = value;
    },
    updateMunicipalityVisible(state, value) {
      state.record.municipalityVisible = value;
    },
    updateLegalNameVisible(state, value) {
      state.record.legalNameVisible = value;
    },
    updateChosenNameVisible(state, value) {
      state.record.chosenNameVisible = value;
    },
    updateWhereWasFoundVisible(state, value) {
      state.record.whereWasFoundVisible = value;
    },
    updateSexualIdentityVisible(state, value) {
      state.record.sexualIdentityVisible = value;
    },
    updateCharacteristicVisible(state, value) {
      state.record.characteristicVisible = value;
    },
    updateAgeVisible(state, value) {
      state.record.ageVisible = value;
    },
    updateNationalityVisible(state, value) {
      state.record.nationalityVisible = value;
    },
    updateOccupationVisible(state, value) {
      state.record.occupationVisible = value;
    },
    updateDetailsVisible(state, value) {
      state.record.detailsVisible = value;
    },
    updateBodyStateVisible(state, value) {
      state.record.bodyStateVisible = value;
    },
    updateWeaponVisible(state, value) {
      state.record.weaponVisible = value;
    },
    updateSexualViolenceVisible(state, value) {
      state.record.sexualViolenceVisible = value;
    },
    updateTortureViolenceVisible(state, value) {
      state.record.tortureViolenceVisible = value;
    },
    updateWasOffenderFoundVisible(state, value) {
      state.record.wasOffenderFoundVisible = value;
    },
    updateMainMediaLinkVisible(state, value) {
      state.record.mainMediaLinkVisible = value;
    }
  },
  actions: {
    getOptions({ state, commit }) {
      commit("SET_GETOPTIONS_PENDING", { pending: true });
      axios
        .get(state.host + "api/v1/options", {
          params: {}
        })
        .then(response => {
          //console.log('options', response);
          commit("SET_GETOPTIONS_SUCCESS", {
            pending: false,
            statusCode: response.status,
            data: response.data
          });
        })
        .catch(error => {
          console.log(error);
          commit("SET_GETOPTIONS_FAILURE", {
            pending: false,
            statusCode: error.status
          });
        });
    },
    getReports({ state, commit }) {
      commit("SET_GETREPORTS_PENDING", { pending: true });
      axios
        .get(state.host + "api/v1/reports", {
          params: {}
        })
        .then(response => {
          //console.log('reports', response);
          commit("SET_GETREPORTS_SUCCESS", {
            pending: false,
            statusCode: response.status,
            data: response.data
          });
        })
        .catch(error => {
          console.log(error);
          commit("SET_GETREPORTS_FAILURE", {
            pending: false,
            statusCode: error.status
          });
        });
    },
    createReport({ state, commit }) {
      state.record.updates.push({
        when: new Date(),
        who: state.user.email,
        changes: "Registro inicial",
        comments: "Registro inicial" /*,
        report: {...state.record}*/
      });
      commit("SET_CREATEREPORT_PENDING", { pending: true });
      return axios.post(state.host + "api/v1/reports", {
        features: state.record,
        user: state.user
      });
    },
    updateReport({ state, commit }) {
      //console.log(state.user, 'update beggining');

      state.record.updates.push({
        when: new Date(),
        who: state.user.email,
        changes:
          state.record["edit_reason"] === "update"
            ? "Actualización del caso"
            : "Corrección de errores",
        comments:
          state.record["edit_comments"] /*,
        report: {...state.record}*/
      });
      state.record.reviews = [];
      //console.log(state.user, 'update');
      commit("SET_UPDATEREPORT_PENDING", { pending: true });
      return axios.put(state.host + "api/v1/reports", {
        features: state.record,
        user: state.user['_id']
      });

    },
    deleteReport({ state, commit }) {
      commit("SET_DELETEREPORT_PENDING", { pending: true });
      return axios.delete(state.host + "api/v1/reports", {
        params: {
          id: state.record.id,
          folio: parseInt(state.record.folio,10),
          user: state.user['_id']
        }
      });
    },
    createUser({ state, commit }) {
      commit("SET_CREATEUSER_PENDING", { pending: true });
      return axios.post(state.host + "api/v1/register", state.userEdit);
    },
    updateUser({ state, commit }) {
      commit("SET_UPDATEUSERS_PENDING", { pending: true });
      return axios.put(state.host + "api/v1/updateUser", {
        features: state.userEdit,
        user: state.user
      });
    },
    updatePassword({ state, commit }) {
      commit("SET_UPDATEPASSWORD_PENDING", { pending: true });
      return axios.put(state.host + "api/v1/updatePassword", {
        features: state.userEdit,
        user: state.user
      });
    },
    deleteUser({ state, commit }) {
      commit("SET_DELETEUSER_PENDING", { pending: true });
      //console.log(state.userEdit);
      return axios.delete(state.host + "api/v1/deleteUser", {
        params: {
          id: state.userEdit._id,
          user: state.user['_id']
        }
      });
    },
    getUserList({ state, commit }) {
      commit("SET_GETUSERS_PENDING", { pending: true });
      return axios
        .get(state.host + "api/v1/getUsers", {
          params: {}
        })
        .then(response => {
          commit("SET_GETUSERS_SUCCESS", {
            pending: false,
            statusCode: response.status,
            data: response.data
          });
        })
        .catch(error => {
          console.log(error);
          commit("SET_GETUSERS_FAILURE", {
            pending: false,
            statusCode: error.status
          });
        });
    },
    uploadImage({ state, commit }, imageData) {
      commit("SET_UPLOADIMAGE_PENDING", { pending: true });

      return axios.post(state.host + "api/v1/images", imageData);
    },
    uploadPicture({ state, commit }, imageData) {
      commit("setIsLoadingState", true);
      axios.post(state.host + "api/v1/picture", imageData).then(response => {
        //console.log(response, response.data.url);
        commit("updatePicture", response.data.url + "?" + new Date().getTime());
        commit("setIsLoadingState", false);
      })
      .catch(error => {
        console.log("error", error);
        commit("setIsLoadingState", false);
      });
    },
    uploadUserProfileImg({ state, commit }, imageData) {
      commit("setIsLoadingState", true);
      axios.post(state.host + "api/v1/ProfileImg", imageData).then(response => {
        commit("updateUserProfileImg", response.data.result);
        commit("setIsLoadingState", false);
      })
      .catch(error => {
        console.log("error", error);
        commit("setIsLoadingState", false);
      });
    },
    updateCsv({ state, commit }) {
      commit("SET_UPDATECSV_PENDING", { pending: true });

      return axios.post(state.host + "api/v1/generateCsv");
    },
    login({ state, commit }, userData) {
      commit("SET_LOGIN_PENDING", { pending: true });
      return axios.post(state.host + "api/v1/login", {
        email: userData.email,
        password: userData.password
      });
    },
    addReview({ state, commit }) {
      // console.log(state.record.reviews)
      state.record.reviews.push({
        when: new Date(),
        who: state.user.email,
        changes:
          state.record["review_reason"] === "right"
            ? "La postal es correcta"
            : "La postal tiene errores",
        comments: state.record["review_comments"]
      });
      commit("SET_ADDREVIEW_PENDING", { pending: true });
      return axios.put(state.host + "api/v1/reports", {
        features: state.record,
        user: state.user['_id']
      });
    },
    addToken({ state, commit }) {
      // commit('SET_ADDTOKEN_PENDING', { pending: true })
      return axios.post(state.host + "api/v1/token", {
        email: state.user.email,
        role: state.user.role,
        token: state.currentToken
      });
    },
    sendPushNotification({ state, commit }, notification) {
      // commit('SET_ADDTOKEN_PENDING', { pending: true })
      return axios.post(state.host + "api/v1/notification", {
        notification: notification
      });
    }
  }
});
